(function() {
    'use strict';
    // TODO: remove this once gaf-ng-components doesn't rely on DashboardLegacy.Constants
    angular.module('MW.DashboardLegacy.Constants', ['MW.Configuration'])
        .constant('DASHBOARD_LEGACY_VIEWS_FOLDER', '/views')
        .constant('DASHBOARD_LEGACY_TRANSLATIONS', '/translations')
        .factory('DASHBOARD_LEGACY_VIEW_PATH', ['DASHBOARD_LEGACY_URL', 'DASHBOARD_LEGACY_VIEWS_FOLDER', function getDashboardLegacyViewPathValue (DASHBOARD_LEGACY_URL, DASHBOARD_LEGACY_VIEWS_FOLDER) {
            return DASHBOARD_LEGACY_URL + DASHBOARD_LEGACY_VIEWS_FOLDER;
        }]);
}());
